// extracted by mini-css-extract-plugin
export default {"form":"Introduction_form__6PVF-","input":"Introduction_input__yM-bv","Introduction__formControl":"Introduction_Introduction__formControl__K+5uo"};